/**
 * Format large numbers compactly (e.g., 1.2M, 500K)
 */
export const formatCompactNumber = (num) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num.toLocaleString();
};

/**
 * Convert database age rating names to display names
 */
const AGE_RATING_MAP = { all_ages: 'All Ages', teens: 'Teens', tweens: 'Tweens', adults: 'Adults' };

export const formatAgeRating = (dbName) => {
  if (!dbName) return dbName;
  return AGE_RATING_MAP[dbName] || dbName;
};
